import { data } from '../../svg/Price/data';
import { makeIcon } from '../makeIcon';

export const Price = makeIcon(data, 'price', 'Price');

export default Price;
